import { ScreenRoute } from "../constants/ScreenRouteConstant"
import { isChemistStoreLoaded } from "./CommonUtils"

export const NavigateToAppBaseScreen = (navigation) => {
    isChemistStoreLoaded() ? navigation.replace(ScreenRoute.tab_controller_screen) :
        navigation.replace(ScreenRoute.dashboard_screen)
}